import api from "../services/api";

// Create template (handles both JSON and FormData)
export const createTemplate = async (templateData) => {
  const isFormData = templateData instanceof FormData;
  return api.post("/api/templates", templateData, {
    headers: {
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
    },
  });
};

// Submit template to Meta for approval
export const submitTemplateForApproval = async (templateId, phoneId = null) => {
  return api.post(`/api/templates/${templateId}/submit`, { phoneId });
};

// Refresh template status from Meta
export const refreshTemplateStatus = async (templateId) => {
  return api.post(`/api/templates/${templateId}/refresh-status`, {});
};

// Get templates for dropdowns (id, name only) - lightweight
export const getTemplateDropdownList = async (filters = {}) => {
  const requestBody = {
    wabaId: filters.wabaId || null,
    phoneId: filters.phoneId ? (typeof filters.phoneId === 'string' ? parseInt(filters.phoneId, 10) : filters.phoneId) : null,
    limit: filters.limit || 1000,
    offset: filters.offset || 0,
    ...(filters.status && { status: filters.status }),
  };
  if (requestBody.phoneId === null) delete requestBody.phoneId;
  return api.post("/api/templates/dropdown-list", requestBody);
};

// Get filter options (used languages/categories)
export const getTemplateFilterOptions = async (filters = {}) => {
  const requestBody = {
    phoneId: filters.phoneId
      ? typeof filters.phoneId === "string"
        ? parseInt(filters.phoneId, 10)
        : filters.phoneId
      : null,
    wabaId: filters.wabaId || null,
  };
  if (requestBody.phoneId === null) delete requestBody.phoneId;
  return api.post("/api/templates/filter-options", requestBody);
};

// Get all templates for user
export const getTemplates = async (filters = {}) => {
  // Ensure phoneId is a number if provided
  const requestBody = {
    wabaId: filters.wabaId || null,
    phoneId: filters.phoneId ? (typeof filters.phoneId === 'string' ? parseInt(filters.phoneId, 10) : filters.phoneId) : null,
    limit: filters.limit || 50,
    offset: filters.offset || 0,
    ...(filters.status && { status: filters.status }),
    ...(filters.category && { category: filters.category }),
    ...(filters.language && { language: filters.language }),
    ...(filters.categories?.length && { categories: filters.categories }),
    ...(filters.languages?.length && { languages: filters.languages }),
    ...(filters.statusFilters?.length && { statusFilters: filters.statusFilters }),
    ...(filters.daysBack && { daysBack: filters.daysBack }),
    ...(filters.searchTerm && { searchTerm: filters.searchTerm }),
  };
  
  // Remove null phoneId to avoid sending null
  if (requestBody.phoneId === null) {
    delete requestBody.phoneId;
  }
  
  return api.post("/api/templates/get-templates", requestBody);
};

// Get single template
export const getTemplateById = async (templateId) => {
  return api.get(`/api/templates/${templateId}`);
};

// Update template (handles both JSON and FormData)
export const updateTemplate = async (templateId, templateData) => {
  const isFormData = templateData instanceof FormData;
  return api.put(`/api/templates/${templateId}`, templateData, {
    headers: {
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
    },
  });
};

// Update template status
export const updateTemplateStatus = async (templateId, status) => {
  return api.put(`/api/templates/${templateId}/status`, { status });
};

// Delete template
export const deleteTemplate = async (templateId) => {
  return api.delete(`/api/templates/${templateId}`);
};

// Generate template from AI prompt
export const generateTemplateFromAI = async (data) => {
  return api.post("/api/templates/generate-ai", data);
};

/* ==========================================================
   🔄 TEMPLATE SYNC APIs
========================================================== */

// Sync all templates from Meta for a specific WABA
export const syncTemplatesFromMeta = async (wabaId, phoneId) => {
  return api.post("/api/templates/sync", { wabaId, phoneId }, {
    timeout: 120000, // 2 minute timeout for sync operations
  });
};
